import * as types from './types';

export default {
  [types.CONFIGURATION_LOADED](state, payload) {
    state.BO_IS_V2 = payload.BO_IS_V2;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/conf/mutations.js